import runtimeEnv from '@mars/heroku-js-runtime-env'

const env = runtimeEnv()

window.General = {}
